import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { getEffectiveRole } from '@/lib/roles';

export default function OnboardingGate({ children }: { children: React.ReactNode }) {
  const { profile, loading } = useAuth();
  const loc = useLocation();

  if (loading) return null;

  const eff = getEffectiveRole(profile);

  // If onboarding not complete, send to onboarding first
  // BUT allow access to home page, awaiting approval, and other non-protected routes
  if (!profile?.onboarding_completed) {
    // Allow access to home page, awaiting approval, and other public routes
    if (loc.pathname === '/' || 
        loc.pathname.startsWith('/auth/') || 
        loc.pathname.startsWith('/about') || 
        loc.pathname.startsWith('/contact') ||
        loc.pathname.includes('/awaiting-approval') ||
        loc.pathname.includes('/pending-approval')) {
      return <>{children}</>;
    }
    
    // Only redirect to onboarding for protected routes
    if (eff === 'employer') return <Navigate to="/employer/onboarding" replace />;
    if (eff === 'job_seeker') return <Navigate to="/job-seeker/onboarding" replace />;
  }

  // Only after onboarding is complete, check verification status
  if (profile?.verification_status === 'pending') {
    if (eff === 'employer') return <Navigate to="/employer/awaiting-approval" replace />;
    if (eff === 'job_seeker') return <Navigate to="/job-seeker/awaiting-approval" replace />;
  }

  // Admins never get blocked by the gate
  return <>{children}</>;
}